import { create } from "zustand";

const useComponentWidthStore = create<{
  componentWidth: number | undefined | null;
  setComponentWidth: (componentWidth: number | undefined | null) => void;
}>(set => ({
  componentWidth: null,
  setComponentWidth: componentWidth => set({ componentWidth }),
}));

export default useComponentWidthStore;